module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f07519_banner_800x600.7e7c6d74.png";